
/**
 * Given an object containing a variety of images for a product, return the best image for display to represents that product.
 * @param imageObject   {object} The image object that is returned as part of a product object.
 * @param imageBias     {String} The preferred size of the image returned. (valid values are "large", "medium" or "small")
 * @returns {String} returns a normalized product description for use on the URL.
 */
export default function getBestProductImage(image, imageBias){
  function isValidImage(imagePath) {
    const validImage = !!imagePath && imagePath !== 'image.not.available';
    return validImage
  }
  const biases = {
    large: "extraLargeImage,largeImage,manufacturerExtraLargeImage,manufacturerLargeImage,smallImage,manufacturerSmallImage",
    medium: "largeImage,smallImage,extraLargeImage,manufacturerLargeImage,manufacturerSmallImage,manufacturerExtraLargeImage",
    small: "smallImage,largeImage,extraLargeImage,manufacturerSmallImage,manufacturerLargeImage,manufacturerExtraLargeImage",
  }
  const noImageAvailable = {
    large: "/content/dam/insight-web/source/img/noImageAvailable_150x112.png",
    medium: "/content/dam/insight-web/source/img/noImageAvailable_150x112.png",
    small: "/content/dam/insight-web/source/img/noImageAvailable_150x112.png"
  }

  const bias = biases[imageBias] || biases.large;
  const biasArray = bias.split(",");
  const bestImageKey = biasArray.find(imageSize => isValidImage(image[imageSize]))
  const bestImage = image[bestImageKey] || noImageAvailable[imageBias] || noImageAvailable.large;
  return bestImage;
};
